import { render } from "./ViewerTagsAddModal.vue?vue&type=template&id=dc072052&scoped=true"
import script from "./ViewerTagsAddModal.vue?vue&type=script&lang=js"
export * from "./ViewerTagsAddModal.vue?vue&type=script&lang=js"

import "./ViewerTagsAddModal.vue?vue&type=style&index=0&id=dc072052&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc072052"]])

export default __exports__